import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "waiting",
  class: "py-10 flex flex-col justify-center items-center gap-3"
}
const _hoisted_2 = { class: "font-bold text-md text-h-primary-500" }
const _hoisted_3 = {
  key: 0,
  class: "text-h-error-400"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  id: "errors"
}
const _hoisted_6 = { class: "text-lg mb-2" }
const _hoisted_7 = { class: "flex items-center font-bold gap-3 my-3 text-sm text-red-400 w-max" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = {
  key: 0,
  class: "text-black font-bold text-sm md:text-base"
}
const _hoisted_10 = {
  key: 1,
  class: "bg-red-400 rounded-md p-2 text-white"
}
const _hoisted_11 = {
  key: 0,
  class: "flex flex-wrap gap-2 justify-center md:justify-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImportBtn = _resolveComponent("ImportBtn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_ImportBtn, {
      onOnUpload: _ctx.onUpload,
      name: _ctx.buttons.first,
      btnStyle: _ctx.btnStyle,
      btnIcon: _ctx.btnIcon,
      btnDisabled: _ctx.btnDisabled
    }, null, 8, ["onOnUpload", "name", "btnStyle", "btnIcon", "btnDisabled"]),
    _createVNode(_component_Dialog, {
      header: 
        _ctx.data?.fileError == true
          ? _ctx.$t('csvImport.headers.listError')
          : _ctx.data?.errors !== ''
          ? _ctx.$t('csvImport.headers.errorReport')
          : _ctx.$t('csvImport.headers.loading')
      ,
      visible: _ctx.display,
      "onUpdate:visible": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.display) = $event)),
        _ctx.onClose
      ],
      onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.display = false)),
      closable: _ctx.data.errors !== '' || _ctx.data?.fileError == true,
      draggable: false,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '40vw' },
      modal: true
    }, {
      footer: _withCtx(() => [
        (_ctx.data?.csv !== '' || _ctx.data?.fileError == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_ImportBtn, {
                onOnUpload: _ctx.onUpload,
                name: _ctx.buttons.second,
                btnStyle: "btn-outline"
              }, null, 8, ["onOnUpload", "name"]),
              (_ctx.data?.fileError == false)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-upload",
                    label: "Baixar relatório",
                    class: "btn-primary p-button-sm",
                    onClick: _ctx.onDownload
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_ctx.data.errors == '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_icon, {
                name: "md-uploadfile-outlined",
                class: "text-gray-400",
                scale: 4
              }),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.data?.file?.name), 1),
              (_ctx.data?.fileError == true)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t("csvImport.fileError")), 1))
                : _createCommentVNode("", true),
              (_ctx.data?.fileError == false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_ProgressBar, {
                      mode: "indeterminate",
                      class: "progressbar-style w-60",
                      style: _normalizeStyle({ height: '0.5em' })
                    }, null, 8, ["style"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.errors !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("csvImport.errors")), 1),
              (_ctx.showErrors)
                ? (_openBlock(), _createBlock(_component_ScrollPanel, {
                    key: 0,
                    style: { width: '100%', maxHeight: '400px' }
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.errors, (error, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(error), (item, index) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: index,
                                  class: "flex gap-3"
                                }, [
                                  (item !== 'Error')
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", {
                        pt: "Linha ",
                        en: "Line ",
                      }).concat(error[item]?.replaceAll('"', " "))) + ": ", 1))
                                    : (item == 'Error')
                                      ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.service.errorHandler(error[item])), 1))
                                      : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["header", "visible", "closable", "onUpdate:visible"])
  ]))
}